export default __webpack_public_path__ + "static/10-most-instagrammable-places-on-earth-america-e38db3002b7dd5464fc29a47fee9facb.jpg";